<template>
  <div
    id="app">
    <app-loading
      v-if="loading"
    />
    <router-view
      v-else
    />
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import AppLoading from '@/components/AppLoading';
import notification from '@/mixins/notification';
import { loadLanguage } from '@/plugins/vue-i18n';

export default {
  name: 'App',
  components: {
    AppLoading,
  },
  mixins: [notification],
  computed: {
    ...mapGetters({
      authenticated: 'user/authenticated',
    }),
    loading() {
      return !this.$store.getters.initialized || !this.$store.getters.themed;
    },
  },
  watch: {
    authenticated: {
      immediate: true,
      handler(value) {
        if (value) {
          this.getProfile();
          this.getEngineStatus();
        }
      }
    },
  },
  methods: {
    ...mapActions({
      getProfile: 'user/profile',
      getEngineStatus: 'usage/getEngineStatus',
    }),
  },
  created() {
    const unwatchHttp = this.$store.watch(
      () => this.$store.getters.httped,
      () => {
        this.$store.dispatch('usage/initialize');
        this.$store.dispatch('branding');
        unwatchHttp();
      },
    );
    // const unwatchLang = this.$store.watch(
    //   () => this.$store.getters.language,
    //   (lang) => {
    //     if (lang) {
    //       loadLanguage(lang);
    //       unwatchLang();
    //     }
    //   },
    // );
  },
};
</script>

<style lang="scss">
.grecaptcha-badge {
  visibility: hidden;
}
</style>